import * as React from 'react';
import PropTypes from 'prop-types';
import { PaymentTerm } from './PaymentTerm';
import { withHoc } from '../../Context/Provider';
import { payment as Language } from '../../Util/language.json';
import '../../styles/payment.css';
import PropTypesPreset, { auth as AuthPreset } from '../../Util/PropTypesPreset';

const propTypes = {
  auth: PropTypes.shape(AuthPreset).isRequired,
  history: PropTypes.shape(PropTypesPreset.history).isRequired,
  signOut: PropTypes.func,
};

const defaultProps = {
  auth: {
    _id: PropTypes.string,
  },
};

type DBUsePlan = 'B_365day' | 'B_90day' | 'B_30day' | 'A_30day' | 'A_90day' | 'A_365day';
type Product = {
  siteId: string,
  productId: string,
  price: string,
  name: string,
  plan: DBUsePlan,
};

// plan 구매정보
const priceList: Product[] = [
  {
    siteId: '24408403',
    sitePwd: '8403bzda',
    productId: 'A_30⽇',
    price: '3400',
    name: 'Ａプラン　 ３０日',
    plan: 'A_30day',
    day: '３０日',
  },
  {
    siteId: '24408406',
    sitePwd: '8406bzda',
    productId: 'A_90⽇',
    price: '9400',
    name: 'Ａプラン　 ９０日',
    plan: 'A_90day',
    day: '９０日',
  },
  {
    siteId: '24408407',
    sitePwd: '8407bzda',
    productId: 'A_365⽇',
    price: '24000',
    name: 'Ａプラン ３６５日',
    plan: 'A_365day',
    day: '３６５日',
  },
  {
    siteId: '24408403',
    sitePwd: '8403bzda',
    productId: 'B_30⽇',
    price: '4200',
    name: 'Ｂプラン　 ３０日',
    plan: 'B_30day',
    day: '３０日',
  },
  {
    siteId: '24408406',
    sitePwd: '8406bzda',
    productId: 'B_90⽇',
    price: '11800',
    name: 'Ｂプラン　 ９０日',
    plan: 'B_90day',
    day: '９０日',
  },
  {
    siteId: '24408407',
    sitePwd: '8407bzda',
    productId: 'B_365⽇',
    price: '32000',
    name: 'Ｂプラン ３６５日',
    plan: 'B_365day',
    day: '３６５日',
  },
];

class Payment extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.auth._id === '' || props.auth._id === null || props.auth._id === undefined) {
      this.props.history.replace('/');
    }
  }

  render() {
    const {
      signOut,
      auth: { _id },
    } = this.props;
    return (
      <div id={'payment'}>
        <div className={'payment-top'}>
          <div className={'payment-back'} onClick={signOut} />
          <div className={'payment-title'}>{Language.title}</div>
        </div>
        <div className={'payment-middle--info'}>{Language.planCaption}</div>

        {priceList.map(value => {
          return (
            <PaymentTerm productData={value} id={_id} key={value.siteId} />
          );
        })}
        <div className={'payment-price--info'}>
          <p>Timestream 購入案内</p>
          <ul>
            <li>
              {'トライアルの視聴開始後、\n視聴の途中でも購入手続きが行えます。'}
            </li>
          </ul>
          <p>※ 解約通知期限について</p>
          <ul>
            <li>30日視聴の場合、視聴開始後20日以内</li>
            <li>90・365日視聴の場合、残り日数31日以内</li>
          </ul>
          <p>上記の期限を迎える前にホームページの問い合わせページよりご連絡をお願い致します。</p>
        </div>
      </div>
    );
  }
}

Payment.propTypes = propTypes;
Payment.defaultProps = defaultProps;

export default withHoc(Payment);
